import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { DealershipProvider } from "./contexts/dealershipContext";
import { DealershipUserProvider } from "./contexts/dealershipUserContext";
import { RecordingSessionProvider } from "./contexts/recordingSessionContext";
import { SelectVehicleProvider } from "./contexts/selectVehicleContext";
import { UserTrackingProvider } from "./contexts/userTrackingContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

//supressing logs
if (process.env.REACT_APP_ENVIRONMENT !== "development") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
}

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <UserTrackingProvider>
        <SelectVehicleProvider>
          <DealershipProvider>
            <DealershipUserProvider>
              <RecordingSessionProvider>
                <App />
              </RecordingSessionProvider>
            </DealershipUserProvider>
          </DealershipProvider>
        </SelectVehicleProvider>
      </UserTrackingProvider>
    </BrowserRouter>
  </React.StrictMode>
);
